<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{
        $t('BUILDING_COMPLEXES.BUILDING_COMPLEXES_MANAGEMENT')
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="indigo"
        @click="$router.push({ name: 'building_complexes.create' })"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('BUILDING_COMPLEXES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-row>
        <v-col cols="12">
          <building-complexes-list-filters @setFilters="setFilters" />
        </v-col>
        <v-col cols="12">
          <building-complexes
            :items="items"
            :meta="meta"
            :options.sync="options"
          />
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import BuildingComplexes from '@/modules/building_complexes/components/BuildingComplexesList';
import BuildingComplexesListFilters from '@/modules/building_complexes/components/BuildingComplexesListFilters';
import listOptions from '@/modules/_global/mixins/list-options';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'BuildingComplexLayout',

  components: {
    BuildingComplexes,
    BuildingComplexesListFilters
  },

  mixins: [listOptions],

  data() {
    return {};
  },

  computed: {
    ...mapState('building_complex', ['paginationOptions'])
  },

  methods: {
    ...mapActions('building_complex', ['getItemsList'])
  }
};
</script>
